import React from 'react';
import Radium from 'radium';
import {Container} from 'flux/utils';

import Modal from 'react-responsive-modal';
import StockAPI from 'service/api/StockAPI';
import StockStore from 'stores/StockStore';

import DateComponent from 'views/DateComponent';

import ReactTable from 'react-table';

class StockHistoryModal extends React.Component {

    static getStores() {
        return [StockStore];
    }

    static calculateState(prevState, props) {
        const stockProductId = props.stockProduct.stockProductId;

        let newState = {
            histories: StockStore.getStockProductHistory(stockProductId)
        };

        return newState;
    }

    constructor(props) {
        super(props);
        this.state = {openModal: true};
        
        this.handleModalClose = this.handleModalClose.bind(this);
    }

    componentDidMount() {
        const stockProductId = this.props.stockProduct.stockProductId;
        StockAPI.getStockHistories(stockProductId);
    }
    
    componentWillReceiveProps(nextProps) {
        this.setState({openModal: true})
    }

    handleModalClose() {
        this.props.onSuccess();
    }

    render() {
        const stockProduct = this.props.stockProduct;
        const histories = this.state.histories;
        const showLoading = histories? false: true;


        let columns = [{Header: 'Date', accessor: 'createdDate', width: 180,
                            Cell: props => <DateComponent date={props.value} showTime={true} />
                        },
                        {Header: 'Type', accessor: 'actionType', width: 150}, 
                        {Header: 'Quantity', accessor: 'quantity', width: 70},
                        
                        {Header: 'Comment', accessor: 'comment', className: 'stock-history-comment-col'},
                    ];

        return <Modal closeOnOverlayClick={false} open={this.state.openModal} onClose={this.handleModalClose} little 
                        classNames={{ overlay: 'stock-history-overlay', modal: 'stock-history-modal', closeIcon: 'stock-history-modal-close' }}>
                    
                    <h1 style={{color: '#444141'}}>{stockProduct.product.title} - {stockProduct.productSize} = {stockProduct.quantity}</h1>
                    
                    <ReactTable data={histories? histories: []} columns={columns} minRows={5} 
						noDataText="No Histories Found." loading={showLoading} 
						className="stock-history-table" defaultPageSize={10} 
                        sorted={[{ // the sorting model for the table
                            id: 'createdDate',
                            desc: true
                          }]} />
                    
            </Modal>
    }
}

export default Radium(Container.create(StockHistoryModal, {withProps: true}));


// WEBPACK FOOTER //
// ./src/views/admin/StockHistoryModal.js